/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-status-warning-square-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.251 2.5H3.75c-.69 0-1.249.56-1.249 1.249V16.25c0 .69.56 1.249 1.249 1.249h12.5a1.249 1.249 0 001.249-1.249V3.75a1.249 1.249 0 00-1.248-1.25zM9.297 5h1.406v6.25H9.297V5zM10 15a.937.937 0 110-1.875A.937.937 0 0110 15z"/>'
  }
})
